import {KeyboardEvent} from 'react';

import {ProjectItem} from '../data/projects';
import {navigate} from '../lib/navigation';
import {paragraphMuted, reveal} from '../lib/styles';
import {Route} from '../types/routes';

export const ProjectTile = ({body, category, group, imageUrl, imageVariant = 'logo', slug, title}: ProjectItem) => {
  const route = `/projects/${slug}` as Route;
  const groupClassName = group === 'Upcoming Platforms' ? 'nx-project-tile-upcoming-platform' : '';
  const openProject = () => navigate(route);
  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if(event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openProject();
    }
  };

  return (
    <article
      aria-label={`View details for ${title}`}
      className={`nx-project-tile nx-project-tile-${slug} ${groupClassName} ${reveal} grid cursor-pointer overflow-hidden rounded-[var(--nx-radius)] border border-[var(--nx-line)] bg-white transition-[border-color,opacity,transform] duration-[220ms,780ms,220ms] hover:-translate-y-[3px] hover:border-[var(--nx-blue)]`}
      onClick={openProject}
      onKeyDown={handleKeyDown}
      role="link"
      tabIndex={0}>
      {imageUrl ? (
        <div className={`nx-project-image nx-project-image-${imageVariant}`} aria-label={`${title} ${imageVariant === 'book' ? 'cover' : 'logo'} image`} role="img">
          <img alt="" src={imageUrl} />
        </div>
      ) : (
        <div className="nx-project-image grid aspect-[4/3] place-items-center overflow-hidden" aria-label={`${title} placeholder image`} role="img">
          <span className="relative z-[1] rounded-[var(--nx-radius)] bg-[rgba(16,22,36,.88)] px-3 py-[9px] text-[.8rem] font-extrabold uppercase text-white">{category}</span>
        </div>
      )}
      <div className="grid gap-2.5 p-[22px]">
        <p className="m-0 text-[.78rem] font-extrabold uppercase text-[var(--nx-blue)]">{category}</p>
        <h3 className="m-0 text-xl leading-[1.22] text-[var(--nx-ink)]">{title}</h3>
        <span className={paragraphMuted}>{body}</span>
        <span className="mt-2 inline-flex cursor-pointer justify-self-start p-0 font-extrabold text-[var(--nx-blue)] hover:text-[var(--nx-ink)]">View Details</span>
      </div>
    </article>
  );
};
